<template>
  <div
    class="row mb-3 animate__animated"
    :class="show ? 'animate__fadeIn' : 'animate__slideInDown'"
  >
    <div class="col-md-12">
      <div class="card mb-0 shadow">
        <div class="card-body p-3 row">
          <div class="col-4 p-0">
            <!--  -->
            <pie-chart
              :donut="false"
              :data="status"
              :dataset="data"
              legend="left"
              height="200"
            />
          </div>
          <div class="col-8 row pl-4 pr-0 d-flex align-items-center">
            <!-- <t
              v-for="(item, k) in status"
              :key="k"
              class="d-flex align-items-center p-2"
            >
              <div>
                <h3 :style="`background:${item[2]}`">{{ item[0] }}</h3>
                <h1 class="text-center">{{ item[1] }}</h1>
              </div>
            </t> -->
            <table class="table table-sm border" style="height: 100px">
              <thead>
                <tr>
                  <td v-for="(item, k) in status" :key="k">
                    <div class="text-center" :style="`color:${item[2]}`">
                      {{ item[0] }}
                    </div>
                  </td>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td v-for="(item, k) in status" :key="k">
                    <div class="text-center">{{ item[1] }}</div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="col-12 mt-2">
            <h4>{{ tecnicos.length }} Técnicos com mais Ofícios registrados</h4>
            <table class="table table-sm border" style="height: 100px">
              <thead>
                <tr>
                  <td v-for="(item, k) in tecnicos" :key="k">
                    <i
                      class="mdi mdi-home-assistant mdi-24px text-primary"
                      :title="item[1]"
                    ></i>
                    <b
                      >{{ item[0] }}
                      <p
                        v-if="item[3] == $store.state.user.id"
                        title="Parabéns você está fazendo a diferença, continue assim."
                        class="animate__animated animate__pulse animate__infinite float-left mt-2"
                      >
                        <i class="mdi mdi-heart text-danger"></i>
                      </p>
                    </b>
                  </td>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td v-for="(item, k) in tecnicos" :key="k">
                    <div>{{ item[2] }}</div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    props: ["dados", "show"],
    data() {
      return {
        // These labels appear in the legend and in the tooltips when hovering different arcs
        labels: [],
        data: [],
        status: [],
        colors: [],
        tecnicos: [],
      };
    },
    mounted() {
      this.status = this.dados.status.map((item) => [
        item.descricao+"S",
        item.total,
        item.cor,
      ]);
      this.tecnicos = this.dados.tecnicos.map((item) => [
        item.nome,
        item.unidade,
        item.total,
        item.user_id,
      ]);

      this.colors = this.dados.status.map((item) => [item.cor]);
      let colors = this.dados.status.map((item) => item.cor);
      this.data = {
        backgroundColor: colors,
        hoverBackgroundColor: colors,
      };
    },
    methods: {},
  };
</script>